<template>
    <div class="loading" v-if="posts">
        <div class="loader2"></div>
    </div>
</template>
<script>
    export default {
        props: ["posts"],
    };
</script>